import {createQueryKeys} from "@lukemorales/query-key-factory";
import {GetCasesExportRequest} from "@/Stub/V1";

export const Exports = createQueryKeys('exports', {
    cases: (requestParams: GetCasesExportRequest) => [{requestParams}]
})